<script>
import { required } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import Banner from "../components/banner";
import Drawer from "vue-simple-drawer";
import forminput from "../formcomponet/forminput.vue";
import formcombobox from "../formcomponet/formcombobox.vue";
import formtextarea from "../formcomponet/formtextarea.vue";
import mzneposta from "@/models/mzneposta";
import mznmezunlar from "@/models/mznmezunlar";
import { RadioSvgMap } from "vue-svg-map";
import Turkey from "./turkiye.js";
import { getLocationName } from "./utilities";

export default {
  props: {
    WebSiteConfig: [String, Object],
  },
  name: "TooltipHeatMap",
  mixins: [apibtoast, apigeneric, mzneposta, mznmezunlar,Turkey],
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Banner,
    RadioSvgMap,
    Drawer,
    forminput,
    formcombobox,
    formtextarea,
  },
  data() {
    return {
      Turkey,
      Page: {
        PageNumber: "1",
        PageSize: "6",
        PageDataSize: "1",
      },
      MesajPenceresi: false,
      FilitrelemePenceresi: false,
      TableData: {},
      MezunSehir: null,
      IsOgrenci: false,
      Filter: {
        Adisoyadi: "",
        Eposta: "",
        Telefon: "",
        Yasadigisehir: "",
        Calismadurumu: "",
        Isaramadurumu: "",
        Saglikengeli: "",
        Ehliyet: "",
        Cinsiyet: "",
        Bolum: "",
        Fakülte: "",
        Ogrenimdurumu: ""
      },
      Yasadigisehir: "",
      Messagelist: [],

      Over: null,
      FormData: {},
      pointedLocation: null,
      tooltipStyle: null,
    };
  },
  validations: {
    Filter: {
      Adisoyadi: {},
      Eposta: {},
      Telefon: {},
      Yasadigisehir: {},
      Calismadurumu: {},
      Isaramadurumu: {},
      Saglikengeli: {},
      Ehliyet: {},
      Cinsiyet: {},
      Bolum: {},
      Fakülte: {},
      Ogrenimdurumu: {}
    },
    Yasadigisehir: {},
    FormData: {
      Message: { required },
    },
  },
  watch: {
    Yasadigisehir() {

      this.Get();
    },
  },
  methods: {
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
    downDrawer() {
      this.MesajPenceresi = !this.MesajPenceresi;
    },
    Get() {
      this.ActionsFilterGet({
            Service: "OIlIlce",
            Page: this.Page, 
            Filter:"&Kod=" + this.Yasadigisehir ,
          }).then((res) => { 
            if(this.Yasadigisehir){
              this.MezunSehir = res.Data[0].Id
              this.getMezunList();
            }else{
              this.MezunSehir = ''
              this.getMezunList();
            }
    });
      this.FormData = this.mznepostaData;
      this.FormData.Gonderenid = this.TokenUserId;
    },
    getMezunList(){
      let Filter =
        "&Onay=true" +
        "&Arkadaskontroluserid=" +
        this.TokenUserId +
        "&Adisoyadi=" +
        this.Filter.Adisoyadi +
        "&Eposta=" +
        this.Filter.Eposta +
        "&Telefon=" +
        this.Filter.Telefon +
        "&Yasadigisehir=" +
        this.MezunSehir +
        "&Calismadurumu=" +
        this.Filter.Calismadurumu +
        "&Isaramadurumu=" +
        this.Filter.Isaramadurumu +
        "&Saglikengeli=" +
        this.Filter.Saglikengeli +
        "&Ehliyet=" +
        this.Filter.Ehliyet +
        "&Cinsiyet=" +
        this.Filter.Cinsiyet + 
        "&Bolum=" +
        this.Filter.Bolum + 
        "&Fakülte=" + 
        this.Filter.Fakülte
        "&Ogrenimdurumu=" +
        this.Filter.Ogrenimdurumu;
      this.ActionsFilterGet({
        Service: this.$config.API_URL_2 + "mznmezunlar",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.ÖğrenciMi();
      });
    },
    MauseOver(gelen) {
      if (gelen) {
        this.Over = gelen.target.dataset.iladi;
      }
    },
    ArkadasListesiAdd(ArkadasId) {
      let FormData = {
        Userid: this.TokenUserId,
        Arkadasuserid: ArkadasId,
      };
      this.Post(this.$config.API_URL_2 + "mznarkadaslistesi", FormData);
    },
    onSubmit() {
      this.$v.FormData.$touch();
      if (!this.$v.FormData.$invalid) {
        this.FormData.Creationtime = new Date();
        var FormData = [];
        for (let Data in this.Messagelist) {
          FormData.push({
            Gonderenid: this.TokenUserId,
            Aliciid: this.Messagelist[Data],
            Creationtime: new Date(),
            Message: this.FormData.Message,
          });
        }

        this.Post(this.$config.API_URL_2 + "mzneposta/PostList", FormData).then(
          (res) => {
            if (res) {
              this.downDrawer();
              this.FormData.Message = null;
              this.Messagelist = [];
            }
          }
        );
      }
    },
    pointLocation(event) {
      this.pointedLocation = getLocationName(event.target);
    },
    unpointLocation() {
      this.pointedLocation = null;
      this.tooltipStyle = { display: "none" };
    },
    moveOnLocation(event) {
      this.tooltipStyle = {
        display: "block",
        top: `${event.clientY + 10}px`,
        left: `${event.clientX - 100}px`,
      };
    },
    getLocationClass(location, index) {
      // Generate heat map
      return `svg-map__location svg-map__location--heat${index % 4}`;
    },
    ÖğrenciMi() {

      this.ActionsFilterGet({
        Service: this.$config.API_URL_2 + "mznmezunlar",
        Page: this.Page,
        Filter: "&Userid=" + this.TokenUserId,
      }).then((res) => {
        if (res.Data.length > 0) {
          this.IsOgrenci = true;
        }

      });


    },
  },
};
</script>
<style scoped>
.examples__block__map__tooltip {
  position: fixed;
  width: 150px;
  background-color: #fff;
  border-radius: 5px;
  text-align: center;
  padding: 5px 0px;
}
</style>
<style src="vue-svg-map/dist/index.css">

</style>
<template>
  <Loader>
    <Layout>
      <Banner />

      <div class="container"> 
        <div class="haritage">
          {{ Over }}
 
          <div style="max-height: 400px" >
            <div class="examples__block__map__tooltip" :style="tooltipStyle">
              {{ pointedLocation }}
            </div>
            <radio-svg-map v-model="Yasadigisehir" :map="Turkeydata" @mouseover="pointLocation" @mouseout="unpointLocation"
              @mousemove="moveOnLocation"/>



          </div>
        </div>

        <div class="search-bar"
          > 
          <div class="row c-flex">
            <div class="col-md-2 l-flex">
              <div class="form-group full-width">
                <input v-model="Filter.Adisoyadi" type="name" name="name" class="form-control" placeholder="Ad Soyad" />
              </div>
            </div>
            <div class="col-md-2 l-flex">
                    <div class="form-group full-width">
                        <b-form-group placeholder="Öğrenim Durumu">
                                          <select v-model="Filter.Ogrenimdurumu" class="form-select">
                                            <option value="">Seçiniz...</option>
                                            <option value="Ön lisans">Ön lisans</option>
                                            <option value="Yüksek lisans">Yüksek lisans</option> 
                                            <option value="Lisans">Lisans</option>
                                            <option value="Doktora">Doktora</option>
                                          </select>
                       </b-form-group>
                    </div>
                  </div>
                  
                  <div class="col-md-2 l-flex">
                    <div class="form-group full-width">
                      <input v-model="Filter.Fakülte" type="name" name="number" class="form-control"
                        placeholder="MYO/Fakülte/Enstitü" />
                    </div>
                  </div>
                  <div class="col-md-2 l-flex">
                    <div class="form-group full-width">
                      <input v-model="Filter.Bolum" type="name" name="name" class="form-control"
                        placeholder="Bölüm" />
                    </div>
                  </div>
                  <div class="col-md-2 l-flex">
                    <div class="form-group full-width">
                      <input v-model="Filter.Mezuniyetyili" type="number" name="number" class="form-control"
                        placeholder="Mezuniyet Tarihi" />
                    </div>
                  </div>
         <!--     <div class="col-md-2 l-flex">
                    <div class="form-group full-width">
                      <input v-model="Filter.Fakülte" type="name" name="number" class="form-control"
                        placeholder="MYO/Fakülte/Enstitü" />
                    </div>
                  </div> 
            <div class="col-md-2 l-flex">
                    <div class="form-group full-width">
                      <input v-model="Filter.Bolum" type="name" name="name" class="form-control"
                        placeholder="Bölüm" />
                    </div>
                  </div>
     
               <div class="col-md-2 l-flex">
              <div class="form-group full-width">
                <input
                  v-model="Filter.Eposta"
                  class="form-control"
                  placeholder="E-Posta"
                />
              </div>
            </div>
            <div class="col-md-2 l-flex">
              <div class="form-group full-width">
                <input
                  v-model="Filter.Telefon"
                  type="number"
                  name="number"
                  class="form-control"
                  placeholder="Telefon"
                />
              </div>
            </div> -->
            <div class="col-md-1">
              <button type="button " @click="Get()" class="btn btn-dark full-width">
                Ara
              </button>
            </div>
            <div class="col-md-1">
              <button type="button " @click="Yasadigisehir = ''" class="btn btn-dark full-width">
                İl İptal
              </button>
            </div>
            <div class="col-md-2 l-flex">
              <b-button type="button" class="btn btn-secondary btn-rounded full-width" @click="rightDrawer"
                v-if="WebSiteConfig.Mezunharitagelismisfiltreleme">
                <i class="mdi mdi-text-search"></i>
                {{ $t("mznisilanlari.Page.GelismisFiltreleme") }}
              </b-button>
            </div>
            <!-- <div class="col-md-2 l-flex">
              <button
                type="button "
                @click="downDrawer"
                class="btn btn-success"
              >
                Mesaj Gönder
              </button>
            </div> -->
          </div>
        </div>

        <div class="data-collection" v-if="WebSiteConfig.Mezunharitatablogozuksun && ((WebSiteConfig.Mezunlarbirbirinigorsun && IsOgrenci) || !IsOgrenci)">
          <span class="location"></span>
          <div class="students">
            <div class="row">
              <div class="col-md-4 mt-3" v-for="(Data, index) in TableData" :key="index">
                <div class="student-card">
                  <div class="row">
                    <!--  <div class="col-sm-6">
                      <b-form-checkbox
                        :value="Data.Userid"
                        v-model="Messagelist"
                      ></b-form-checkbox> 
                    </div>  -->
                    <div class="col-sm-12">
                      <div class="text-sm-end">
                        <b-button-group>
                          <router-link class="btn btn-info bx bxs-user-detail mx-auto"
                            style="color: #00758f; font-size: 20px;" id="topnav-components" :to="'profil/' + Data.Id"
                            role="button">
                            <i></i>
                          </router-link>
                          <b-button v-if="!Data.Arkadasmi && TokenUserId != Data.Userid" variant="primary"
                            @click="ArkadasListesiAdd(Data.Userid)"><i class="bx bx-user-plus"></i></b-button>
                        </b-button-group>
                      </div>
                    </div>
                  </div>
                  <figure class="student-card-figure">
                    <img v-if="Data.Fotograf" class="w-100" :src="$config.FILES_URL + 'web/' + Data.Fotograf" />
                    <img v-if="Data.Fotograf == null" class="w-100" src="@/assets/images/usericon.png" alt="" />
                  </figure>
                  <div class="sutudent-card-about">
                    <div class="group">
                      <p class="group-title">{{ Data.Adisoyadi }}</p>
                    </div>
                    <div class="group" v-if="
                      (Data.Arkadasmi == true &&
                        JSON.parse(Data.Gizlilik).İletisimBilgiler != 0) ||
                      (Data.Arkadasmi == false &&
                        JSON.parse(Data.Gizlilik).İletisimBilgiler == 2)
                    ">
                      <p class="group-title">İletişim Bilgileri</p>
                      <p class="group-data">
                        {{ Data.Telefon }}
                      </p>
                      <p class="group-data">
                        {{ Data.Eposta }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-pagination class="
                pagination pagination-rounded
                justify-content-end
                mb-2
                mt-3
              " v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize"
              aria-controls="my-table" @input="ChangePage(DefaultPage)">
            </b-pagination>
          </div>
        </div>
      </div>
      <Drawer @close="downDrawer" :align="'down'" :closeable="true" :maskClosable="true" :zIndex="1002"
        v-if="WebSiteConfig.Mezunharitagelismisfiltreleme">
        <div v-if="MesajPenceresi">
          <div class="offcanvas-header">
            <h5 id="offcanvasBottomLabel">Toplu Mesaj Gönder</h5>
          </div>
          <div class="offcanvas-body">
            <Form @submit.prevent="onSubmit" class="p-3">
              <div class="row">
                <div class="col-md-12">
                  <formtextarea :FormDataType="FormDataType.Message" :Value="FormData.Message" :v="$v.FormData.Message"
                    @input="FormData.Message = $event" />
                </div>
              </div>

              <div class="text-sm-end">
                <button class="btn btn-primary" :disabled="Messagelist.length == 0" type="submit">
                  {{ $t("mzneposta.AddEdit.Button") }}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </Drawer>

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("mznmezunlar.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("mznmezunlar.Filtreleme.Content") }}
            <div class="mb-3 mt-4">
              <forminput :FormDataType="{
                FieldName: 'Adisoyadi',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Adisoyadi'),
              }" :Value="Filter.Adisoyadi" :v="$v.Filter.Adisoyadi" @input="Filter.Adisoyadi = $event" />
            </div>
            <!--     <div class="mb-3 mt-4">
             <forminput
                :FormDataType="{
                  FieldName: 'Tckimlikno',
                  Field: 'input',
                  FieldTitle: $t('mznmezunlar.Filtreleme.Tckimlikno'),
                }"
                :Value="Filter.Tckimlikno"
                :v="$v.Filter.Tckimlikno"
                @input="Filter.Tckimlikno = $event"
              />
            </div> -->
            <div class="mb-3 mt-4">
              <forminput :FormDataType="{
                FieldName: 'Eposta',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Eposta'),
              }" :Value="Filter.Eposta" :v="$v.Filter.Eposta" @input="Filter.Eposta = $event" />
            </div>
            <div class="mb-3 mt-4">
              <forminput :FormDataType="{
                FieldName: 'Telefon',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Telefon'),
              }" :Value="Filter.Telefon" :v="$v.Filter.Telefon" @input="Filter.Telefon = $event" />
            </div>
            <div class="mb-3 mt-4">
              <formcombobox :FormDataType="{
                FieldName: 'Yasadigisehir',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Yasadigisehir'),
                ComboDataArray: FormDataType.Yasadigisehir.ComboDataArray,
              }" :Value="Filter.Yasadigisehir" :v="$v.Filter.Yasadigisehir" @input="Filter.Yasadigisehir = $event" />
            </div>
            <div class="mb-3 mt-4">
              <formcombobox :FormDataType="{
                FieldName: 'Calismadurumu',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Calismadurumu'),
                ComboDataArray: FormDataType.Calismadurumu.ComboDataArray,
              }" :Value="Filter.Calismadurumu" :v="$v.Filter.Calismadurumu" @input="Filter.Calismadurumu = $event" />
            </div>
            <div class="mb-3 mt-4">
              <formcombobox :FormDataType="{
                FieldName: 'Isaramadurumu',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Isaramadurumu'),
                ComboDataArray: FormDataType.Isaramadurumu.ComboDataArray,
              }" :Value="Filter.Isaramadurumu" :v="$v.Filter.Isaramadurumu" @input="Filter.Isaramadurumu = $event" />
            </div>
            <div class="mb-3 mt-4">
              <formcombobox :FormDataType="{
                FieldName: 'Askerlik',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Askerlik'),
                ComboDataArray: FormDataType.Askerlik.ComboDataArray,
              }" :Value="Filter.Askerlik" :v="$v.Filter.Askerlik" @input="Filter.Askerlik = $event" />
            </div>
            <div class="mb-3 mt-4">
              <formcombobox :FormDataType="{
                FieldName: 'Ehliyet',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Ehliyet'),
                ComboDataArray: FormDataType.Ehliyet.ComboDataArray,
              }" :Value="Filter.Ehliyet" :v="$v.Filter.Ehliyet" @input="Filter.Ehliyet = $event" />
            </div>
            <div class="mb-3 mt-4">
              <formcombobox :FormDataType="{
                FieldName: 'Saglikengeli',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Saglikengeli'),
                ComboDataArray: FormDataType.Saglikengeli.ComboDataArray,
              }" :Value="Filter.Saglikengeli" :v="$v.Filter.Saglikengeli" @input="Filter.Saglikengeli = $event" />
            </div>
            <!--      <div class="mb-3 mt-4">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Cinsiyet',
                  Field: 'input',
                  FieldTitle: $t('mznmezunlar.Filtreleme.Cinsiyet'),
                  ComboDataArray: FormDataType.Cinsiyet.ComboDataArray,
                }"
                :Value="Filter.Cinsiyet"
                :v="$v.Filter.Cinsiyet"
                @input="Filter.Cinsiyet = $event"
              />
            </div> -->
            <b-button @click="Get()" class="btn btn-primary" variant="primary">{{
              $t("mznmezunlar.Filtreleme.Button")
            }}</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
